import * as axios from './axios';
import { downloadEpgDataFromCategories } from './epg-database';
import { groupBy } from './group-by';
import { clearEpisodeName, getSeriesTmdbData, getVodTmdbData } from './tmdb';
import { getInfo } from './user_info';

export async function loadGroup(mode) {
  return await axios
    .post('player_api.php', {
      username: getInfo().username,
      password: getInfo().password,
      action: getAddress(mode, true),
    })
    .then((res) => res.data)
    .catch((err) => []);
}

export async function loadPlaylist(mode, group) {
  // Monta os parâmetros, omitindo category_id quando for 'Todos os Canais'
  const params = {
    username: getInfo().username,
    password: getInfo().password,
    action: getAddress(mode, false),
  };

  // Para LIVE com group === 'all' não enviamos category_id para buscar todos os canais
  if (!(mode === 'live' && group === 'all')) {
    params.category_id = isNaN(group) ? '*' : group;
  }

  const result = await axios
    .post('player_api.php', params)
    .then((res) => res.data)
    .catch((err) => []);
  if (mode === 'live' && !isNaN(group) && axios.getIsIptveditor() === true) {
    await downloadEpgDataFromCategories(result);
  }
  //else if(mode==="movie")
  //    result.data = result.data.sort((a,b)=>b.added-a.added)
  //else if(mode==="series")
  //    result.data = result.data.sort((a,b)=>b.last_modified-a.last_modified)
  return result;
}

export async function loadEpg(stream_id, limit = 1) {
  if (axios.getIsIptveditor() === true) return [];

  return await axios
    .post(
      'player_api.php',
      {
        username: getInfo().username,
        password: getInfo().password,
        action: 'get_simple_data_table',
        stream_id: stream_id,
      },
      true
    )
    .catch((err) => [])
    .then((result) => {
      // A API Xtream Codes retorna array direto, não objeto com epg_listings
      if (Array.isArray(result.data)) {
        // Decodificar Base64 dos títulos e descrições
        const decodedEpg = result.data.map((epg) => ({
          ...epg,
          title: epg.title
            ? decodeURIComponent(escape(atob(epg.title)))
            : epg.title,
          description: epg.description
            ? decodeURIComponent(escape(atob(epg.description)))
            : epg.description,
          // Usar timestamps Unix em vez de strings de data
          start: epg.start_timestamp
            ? new Date(parseInt(epg.start_timestamp) * 1000).toISOString()
            : epg.start,
          end: epg.stop_timestamp
            ? new Date(parseInt(epg.stop_timestamp) * 1000).toISOString()
            : epg.end,
        }));

        return { epg_listings: decodedEpg };
      }
      return result.data;
    });
}

export async function loadEpgArray(stream_ids, limit = 2) {
  if (axios.getIsIptveditor() === true) return [];

  const programmes = [];
  const set = new Set();
  const map = {};

  stream_ids
    .filter((x) => !!x)
    .forEach((x) => {
      const id = x.replace(/\.(plus|minus)\d+$/, '');
      set.add(id);

      const shift = x.match(/\.(plus|minus)(?<number>\d+)$/);
      if (shift && shift.groups) {
        const list = map[id] || [];
        list.push(shift.groups.number);
        map[id] = list;
      }
    });
  stream_ids = Array.from(set);

  // Fazer requisições individuais para cada stream_id
  // A API Xtream Codes não suporta batch requests para EPG
  for (let i = 0; i < stream_ids.length; i++) {
    const stream_id = stream_ids[i];

    try {
      const result = await axios.post(
        'player_api.php',
        {
          username: getInfo().username,
          password: getInfo().password,
          action: 'get_simple_data_table',
          stream_id: stream_id,
        },
        true
      );

      if (Array.isArray(result.data)) {
        // Decodificar Base64 dos títulos e descrições
        const decodedEpg = result.data.map((epg) => ({
          ...epg,
          title: epg.title
            ? decodeURIComponent(escape(atob(epg.title)))
            : epg.title,
          description: epg.description
            ? decodeURIComponent(escape(atob(epg.description)))
            : epg.description,
          // Usar timestamps Unix em vez de strings de data
          start: epg.start_timestamp
            ? new Date(parseInt(epg.start_timestamp) * 1000).toISOString()
            : epg.start,
          end: epg.stop_timestamp
            ? new Date(parseInt(epg.stop_timestamp) * 1000).toISOString()
            : epg.end,
        }));

        programmes.push(...decodedEpg);
      }
    } catch (err) {
      console.warn(`Erro ao carregar EPG para stream_id ${stream_id}:`, err);
    }
  }

  const toReturn = groupBy(programmes, 'id');

  return toReturn;
}

export async function getVodInfo(vod_id, name, existingTmdb) {
  let result = null;
  if (axios.getIsIptveditor() === false) {
    result = await axios
      .post('player_api.php', {
        username: getInfo().username,
        password: getInfo().password,
        action: 'get_vod_info',
        vod_id: vod_id,
      })
      .catch((err) => null)
      .then((result) => {
        return result.data;
      });
  }

  if (result && result.info && result.info.cover_big) return result;

  return await getVodTmdbData(name, existingTmdb);
}

export async function getSeriesInfo(series_id, name, only_info, existingTmdb) {
  let result = null;
  if (axios.getIsIptveditor() === false || only_info === false) {
    result = await axios
      .post('player_api.php', {
        username: getInfo().username,
        password: getInfo().password,
        action: 'get_series_info',
        series_id: series_id,
      })
      .catch((err) => null)
      .then((result) => {
        if (result.data && Array.isArray(result.data)) {
          result.data.forEach((x) => {
            if (!x.episode_num && x.episode) x.episode_num = x.episode;
          });
        }
        const data = result.data;
        // Se o provedor não trouxe tmdb_id mas temos existingTmdb da listagem, propague.
        if (data && data.info && !data.info.tmdb_id && existingTmdb) {
          data.info.tmdb_id = existingTmdb;
        }
        return data;
      });
  }

  // Fallback/enriquecimento com TMDB quando info do provedor for insuficiente
  // Ex.: gêneros em inglês ou ausentes. Mantemos mesmo comportamento de movies.
  if (!result || !result.info || !result.info.genre) {
    const enriched = await getSeriesTmdbData(
      name,
      result && result.episodes,
      existingTmdb
    );
    return enriched;
  }

  if (only_info === false) clearEpisodeName(name, result);
  return result;
}

const getAddress = (mode, group) => {
  switch (mode) {
    case 'live':
      if (!group) return 'get_live_streams';
      else return 'get_live_categories';
    case 'movie':
      if (!group) return 'get_vod_streams';
      else return 'get_vod_categories';
    case 'series':
      if (!group) return 'get_series';
      else return 'get_series_categories';
    default:
      return '';
  }
};

// Função para mapear epg_channel_id para stream_id
export function mapEpgChannelToStreamId(channels) {
  const epgMap = {};
  channels.forEach((channel) => {
    if (channel.epg_channel_id && channel.stream_id) {
      epgMap[channel.epg_channel_id] = channel.stream_id;
    }
  });
  return epgMap;
}

// Função para carregar EPG usando mapeamento
export async function loadEpgByChannelId(epg_channel_id, epgMap, limit = 1) {
  const stream_id = epgMap[epg_channel_id];
  if (!stream_id) {
    console.warn(
      `Stream ID não encontrado para EPG Channel ID: ${epg_channel_id}`
    );
    return [];
  }
  return await loadEpg(stream_id, limit);
}
